<template>
  <list-layout class="Demo">
    <template slot="filterItem">
      <search-item label="运营商">
        <operator-select
          :accessType="1"
          :value="filters.operateId"
          @input="val => updateFilters({operateId: val,areaIdArr:[]})"
        />
      </search-item>
      <search-item label="区域1">
        <dashboard-area-select
          name='da1'
          :operateId="3"
          :value="filters.areaIdArr1"
          multiple
          @input="val => updateFilters({areaIdArr: val})"
        />
      </search-item>
      <search-item label="区域2">
        <dashboard-area-select
          name='da2'
          :operateId="28"
          :value="filters.areaIdArr2"
          multiple
          @input="val => updateFilters({areaIdArr: val})"
        />
      </search-item>
      <search-item label="区域3">
        <dashboard-area-select
          :operateId="39"
          :value="filters.areaIdArr3"
          multiple
          @input="val => updateFilters({areaIdArr: val})"
        />
      </search-item>
      <!-- <search-item label="区域">
        <area-select
          :value="filters.areaId"
          @input="val => updateFilters({areaId: val})"
        />
      </search-item> -->

      <!-- <search-item label="服务">
        <area-service-select
          :areaId="filters.areaId"
          :filterList="[3]"
          :value="filters.service"
          @input="val => updateFilters({service: val})"
        />
      </search-item> -->
    </template>
  </list-layout>
</template>

<script>
import listMixin from '../../mixins/listPage';

export default {
  mixins: [listMixin],
  created() {
    console.log('in cre');
  },
  data() {
    return {
      filters: {
        operateId: undefined,
        areaIdArr1: [15],
        areaIdArr2: [123],
        areaIdArr3: [128],
        areaId: undefined,
        service: undefined,
      },
    };
  },
  methods: {
    updateFilters(entity) {
      this.filters = {
        ...this.filters,
        ...entity,
      };
    },
  },
};
</script>

<style lang="scss">
.Demo {
  .el-select {
    .el-select__tags {
      height: 90%;
      overflow: hidden;
      input {
        display: none;
      }
    }
    .el-input {
      overflow: hidden;
    }
    .el-input__inner {
      height: 100% !important;
    }
  }
}
</style>
